import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import TableData from "./component/tableData";
import AddHelioConfig from "./component/modal/addNewConfig";
import { get, updateToken } from "../../../helpers/api_helper";
import { useSelector } from "react-redux";
import add_new from "../../../Assets/svg/add_new.svg";
import Select from "react-select";
import debounce from "lodash/debounce";


const HeliocentricConfig = () => {
  const token = useSelector((state) => state.login.token);

  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("create");
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [stocks, setStocks] = useState([]);
  const [selectedStock, setSelectedStock] = useState("");
  const [loadingStocks, setLoadingStocks] = useState(false);

  const stockOptions = [
  { value: "", label: "All Stocks" },
  ...stocks.map((stock) => ({
    value: stock._id,
    label: stock.ticker_name,
  })),];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      let url = "/admin/heliocentric-config";
      if (selectedStock) {
        url = `/admin/heliocentric-config/${selectedStock}`;
      }

      const res = await get(url);

      if (res?.success) {
        setData(res.data.items || []);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [selectedStock]);

const fetchStocks = useCallback(async (search = "") => {
  try {
    setLoadingStocks(true);

    const response = await get(
      `/admin/stock-exchange?skip=0&limit=10&search=${search}`
    );

    if (response?.success) {
      const stockList = response?.data?.items || [];

      setStocks(stockList);

      // optional default select
      if (!selectedStock && stockList.length > 0) {
        setSelectedStock(stockList[0]._id);
      }
    } else {
      setStocks([]);
    }
  } catch (error) {
    console.error("Error fetching stocks", error);
    setStocks([]);
  } finally {
    setLoadingStocks(false);
  }
}, [selectedStock]);

  useEffect(() => {
    fetchStocks();
  }, [fetchStocks]);

    const debouncedFetchStocks = useCallback(
          debounce((searchText) => {
            fetchStocks(searchText);
          }, 1000),
          [fetchStocks]
    );

  useEffect(() => {
  if (token) {
    updateToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (selectedStock) {
      fetchData();
    }
  }, [selectedStock, fetchData]);

  const handleAdd = () => {
    setMode("create");
    setSelectedData(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setMode("edit");
    setSelectedData(item);
    setShowModal(true);
  };

  return (
    <>
      <AddHelioConfig
        showModal={showModal}
        setShowModal={setShowModal}
        mode={mode}
        data={selectedData}
        refresh={fetchData}
      />

      <Container>
        <Row>
          <Col lg="12" className="my-2">
            <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
              <div className="left">
                <h4 className="m-0 fw-bold">HelioCentric Config</h4>
                <p className="m-0 text-muted py-1">
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text.
                </p>
              </div>
              <div style={{ width: "200px" }}>
                <Select
                  options={stockOptions}
                  isLoading={loadingStocks}
                  value={
                    stockOptions.find((opt) => opt.value === selectedStock) || null
                  }
                  onChange={(selectedOption) => {
                    setSelectedStock(selectedOption ? selectedOption.value : "");
                  }}
                  onInputChange={(inputValue, actionMeta) => {
                // prevent unnecessary API call on select
                if (actionMeta.action === "input-change") {
                  debouncedFetchStocks(inputValue);
                }
              }}
                  placeholder="Search or select stock..."
                  isClearable
                />
              </div>
              <div className="right d-flex align-items-center flex-wrap gap-10">
                <Button onClick={handleAdd} className="d-flex align-items-center justify-content-center rounded-pill">
                  Add Config{" "}
                  <span className="icn ms-2">
                    <img src={add_new} alt="" />
                  </span>
                </Button>
              </div>
            </div>
          </Col>

          <Col lg="12">
            {loading ? (
              <Spinner />
            ) : (
              <TableData data={data} onEdit={handleEdit} refresh={fetchData} />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HeliocentricConfig;